<script setup>
const props = defineProps({
  fillColor: { type: String, default: '#F97316' },
  strokeColor: { type: String, default: '#F97316' },
  filled: { type: Boolean, default: false },
})
</script>

<template>
  <svg
    v-if="!filled"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_740_28174)">
      <path
        d="M1.22852 5.39703C1.22852 4.32097 2.10084 3.44864 3.17691 3.44864H16.8157C17.8917 3.44864 18.764 4.32097 18.764 5.39703V17.0874C18.764 18.1635 17.8917 19.0358 16.8157 19.0358H3.17691C2.10084 19.0358 1.22852 18.1635 1.22852 17.0874V5.39703Z"
        :fill="fillColor"
      />
      <path
        d="M6.0995 5.39703V1.50025M13.8931 5.39703V1.50025M3.17691 19.0358H16.8157C17.8917 19.0358 18.7641 18.1635 18.7641 17.0874V5.39703C18.7641 4.32097 17.8917 3.44864 16.8157 3.44864H3.17691C2.10084 3.44864 1.22852 4.32097 1.22852 5.39703V17.0874C1.22852 18.1635 2.10084 19.0358 3.17691 19.0358Z"
        :stroke="strokeColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.32871 4.6791C5.08078 4.6791 4.87988 4.88013 4.87988 5.12792V6.75863C4.87988 7.00655 5.08078 7.20745 5.32871 7.20745C7.63906 7.20905 9.85421 8.12751 11.4881 9.76117C13.1217 11.3949 14.0402 13.6102 14.0419 15.9205C14.0419 16.1684 14.2428 16.3693 14.4907 16.3693H16.1214C16.3692 16.3693 16.5702 16.1684 16.5702 15.9205C16.5678 12.9398 15.3827 10.0819 13.275 7.97411C11.1674 5.8664 8.3094 4.68132 5.32853 4.67893L5.32871 4.6791Z"
        fill="white"
      />
      <path
        d="M5.30967 9.06424C5.07227 9.06424 4.87988 9.257 4.87988 9.49486V11.0595C4.87988 11.2973 5.07227 11.4901 5.30967 11.4901C6.48725 11.4909 7.61647 11.9599 8.4492 12.7943C9.28193 13.6286 9.7501 14.76 9.75085 15.9399C9.75085 16.1777 9.94324 16.3705 10.1806 16.3705H11.7422C11.8586 16.3743 11.9717 16.3307 12.0555 16.2495C12.1392 16.1684 12.1865 16.0566 12.1864 15.9399C12.1825 14.115 11.4563 12.3663 10.1672 11.0772C8.87799 9.78828 7.13106 9.06427 5.30969 9.06427L5.30967 9.06424Z"
        fill="white"
      />
      <path
        d="M5.60599 13.4476C4.82603 13.4476 4.10535 13.8653 3.71535 14.5434C3.32535 15.2214 3.32535 16.0567 3.71535 16.7348C4.10535 17.4129 4.82603 17.8306 5.60599 17.8306C6.18959 17.8424 6.75315 17.6163 7.16787 17.2038C7.58245 16.7914 7.81297 16.2279 7.80661 15.642V15.6157C7.80751 15.0334 7.57453 14.4751 7.16048 14.0672C6.74642 13.6592 6.18611 13.4359 5.60599 13.4476V13.4476Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_740_28174">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.269531)"
        />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5455 2.12962H3.41472C3.01586 2.13036 2.63363 2.28912 2.35163 2.5711C2.06965 2.85308 1.91088 3.23533 1.91016 3.63419V16.765C1.91089 17.1638 2.06965 17.5461 2.35163 17.8281C2.63362 18.11 3.01586 18.2688 3.41472 18.2695H16.5455C16.9444 18.2688 17.3266 18.11 17.6086 17.8281C17.8906 17.5461 18.0494 17.1638 18.0501 16.765V3.63419C18.0493 3.23533 17.8906 2.8531 17.6086 2.5711C17.3266 2.28912 16.9444 2.13034 16.5455 2.12962ZM17.2294 16.7648C17.2294 16.9462 17.1573 17.1202 17.0291 17.2484C16.9009 17.3767 16.7269 17.4487 16.5455 17.4487H3.41472C3.23336 17.4487 3.05934 17.3767 2.9311 17.2484C2.80286 17.1202 2.73082 16.9462 2.73082 16.7648V3.63404C2.73082 3.45268 2.80287 3.27866 2.9311 3.15042C3.05933 3.02217 3.23336 2.95013 3.41472 2.95013H16.5455C16.7269 2.95013 16.9009 3.02219 17.0291 3.15042C17.1574 3.27864 17.2294 3.45267 17.2294 3.63404V16.7648Z"
      :fill="fillColor"
      :stroke="strokeColor"
      stroke-width="0.55"
    />
    <path
      d="M6.36327 4.61536C6.16368 4.61536 6.00195 4.7772 6.00195 4.97667V6.28947C6.00195 6.48905 6.16368 6.65078 6.36327 6.65078C8.22317 6.65207 10.0064 7.39147 11.3218 8.70663C12.6369 10.0219 13.3763 11.8053 13.3776 13.6651C13.3776 13.8647 13.5393 14.0264 13.7389 14.0264H15.0517C15.2512 14.0264 15.413 13.8647 15.413 13.6651C15.4111 11.2656 14.457 8.96485 12.7603 7.26798C11.0636 5.57118 8.76282 4.61715 6.36313 4.61522L6.36327 4.61536Z"
      :fill="fillColor"
    />
    <path
      d="M6.36327 7.89594C6.16368 7.89594 6.00195 8.05767 6.00195 8.25725V9.57004C6.00195 9.76963 6.16368 9.93136 6.36327 9.93136C7.35323 9.932 8.30254 10.3256 9.00259 11.0256C9.70265 11.7257 10.0962 12.675 10.0969 13.665C10.0969 13.8645 10.2586 14.0263 10.4582 14.0263H11.771C11.8688 14.0295 11.9639 13.9929 12.0343 13.9248C12.1047 13.8567 12.1444 13.7629 12.1443 13.665C12.1411 12.1338 11.5306 10.6665 10.4469 9.58491C9.36307 8.50344 7.89446 7.89596 6.36328 7.89596L6.36327 7.89594Z"
      :fill="fillColor"
    />
    <path
      d="M6.36065 11.8486C5.71265 11.8486 5.1139 12.1944 4.78989 12.7556C4.46587 13.3168 4.46587 14.0081 4.78989 14.5694C5.1139 15.1306 5.71265 15.4763 6.36065 15.4763C6.84552 15.4861 7.31373 15.299 7.65828 14.9575C8.00272 14.6162 8.19424 14.1498 8.18895 13.6649V13.6431C8.1897 13.1612 7.99614 12.6991 7.65214 12.3614C7.30814 12.0238 6.84263 11.8389 6.36065 11.8486V11.8486Z"
      :fill="fillColor"
    />
  </svg>
</template>
